// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1_KZF","footer":"ReportModalFilter_footer__3Gg2X"};